/* eslint-disable @typescript-eslint/no-shadow */
import { Component, OnInit } from '@angular/core';

import { PopoverController, NavParams } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';

import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-popover-notificaciones',
  templateUrl: './popover-notificaciones.page.html',
  styleUrls: ['./popover-notificaciones.page.scss'],
})
export class PopoverNotificacionesPage implements OnInit {

  idAdmin: any;
  classUser: any;
  canal: any;
  canales: any;
  canalInicial: any;

  notificacionesAll: any;
  notificacionesUnreadAll: any;
  notificaciones: any;
  global: any;
  moreNotify = false;
  seeAll = false;

  onChange: () => void;

  private _notifyChunk = 30;

  constructor(
    private storage: Storage,
    private navParams: NavParams,
    private popoverController: PopoverController,
    private notificacion: NotificacionesService) {
    this.canales = [];
    this.notificaciones = [];
    this.notificacionesAll = [];
    this.notificacionesUnreadAll = [];
    this.global = 0;
  }

  ngOnInit() {
    this.getCanal();
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec === this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    this.classUser = this.canalInicial;

    this.onChange = this.navParams.get('onChange');
    this.getNotification(this.global);
  }

  getNotification(valor) {
    const value = Number(valor) === 1 ? 1 : 0;

    this.notificacion.getAllNotify(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token,
      this.classUser.canale.url_back, value).subscribe((res: any) => {
        console.log('getNotification', res);
        const { status, datos } = res;

        if (status === 'success') {
          // buffers completos
          this.notificacionesAll = Array.isArray(datos) ? datos : [];
          this.notificacionesUnreadAll = this.notificacionesAll.filter(n =>
            n.status === 0 || n.status === '0' || n.status === false || n.status === 'pendiente'
          );

          // elegir base según v (no `valor` crudo)
          const base = (value === 1) ? this.notificacionesAll : this.notificacionesUnreadAll;

          // primera página + botón
          this.notificaciones = base.slice(0, this._notifyChunk);
          this.moreNotify = this.notificaciones.length < base.length;

          // si usa ChangeDetectionStrategy.OnPush, descomente:
          // this.cdr.markForCheck();
        } else {
          this.notificacionesAll = [];
          this.notificacionesUnreadAll = [];
          this.notificaciones = [];
          this.moreNotify = false;
        }
      });
  }

  loadMoreNotify() {
    const base = (this.global === 1) ? this.notificacionesAll : this.notificacionesUnreadAll;
    const start = this.notificaciones.length;
    const end = start + this._notifyChunk;
    const next = base.slice(start, end);

    this.notificaciones = this.notificaciones.concat(next);
    this.moreNotify = this.notificaciones.length < base.length;
  }

  changeStatus(idNot, status) {
    if (status === 0) {
      const valor = (status === 0) ? 1 : 0;

      const body = {
        status: valor
      };

      this.notificacion.updateStatus(idNot, this.classUser.id, this.classUser.rol, this.classUser.token,
        this.classUser.canale.url_back, body).subscribe((res: any) => {
          console.log('changeStatus', res);

          const { status } = res;

          if (status === 'success') {
            this.getNotification(0);

            if (typeof this.onChange === 'function') {
              this.onChange();
            }
          }
        });
    }
  }

  seeAllNotify(ev?: any) {
    // 1) obtener el nuevo valor desde el select o alternar si no viene evento
    const next = ev?.detail?.value ?? (this.global === 0 ? 1 : 0);

    // 2) normalizar a número (evita "1"/"0" como string)
    this.global = Number(next) === 1 ? 1 : 0;

    // 3) refrescar la lista de inmediato usando el buffer ya cargado
    const base = (this.global === 1) ? this.notificacionesAll : this.notificacionesUnreadAll;
    this.notificaciones = base.slice(0, this._notifyChunk);
    this.moreNotify = this.notificaciones.length < base.length;

    // 4) (opcional) volver a consultar para traer datos frescos
    this.getNotification(this.global);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

}
